import { Tag } from 'antd';
import React, { FunctionComponent, useCallback } from 'react';
import { Gift, GiftStatus } from '../services/gift-service/types';
import StringUtils from '../utils';

/**
 * GiftTag props
 */
interface Props {
  gift: Gift;
}

/**
 * GiftTag Component
 */
const GiftTag: FunctionComponent<Props> = ({ gift }) => {
  const statusColor = useCallback((status: GiftStatus) => {
    if (status === GiftStatus.NEW) return 'purple';
    if (status === GiftStatus.GIFT_REDEEMED) return 'green';
    return 'blue';
  }, []);

  return (
    <Tag color={statusColor(gift.status)}>
      {StringUtils.capitalize((gift.status || 'New').toLowerCase())}
    </Tag>
  );
};

export default GiftTag;
